<template>
    <div v-if="currentUser.permissions.includes('psychologist.read')" class="px-16 px-md-60 pt-16 pt-md-32">
        <div class="row  align-content-start">

            <div class="col-12 mb-24 small d-flex flex-row">
                <router-link class="text-dark d-flex" :to="{ name: 'admin-psychologists' }">
                    <i-back class="i-14 mr-16 fill-gold my-auto"></i-back>
                    <span class="my-auto">{{ $t('general.back')}}</span>
                </router-link>
                <div v-if="update" class="btn btn-outline-primary-dark d-flex justify-content-center ml-auto" @click="impersonate()">
                    <i-user class="fill-primary i-14 mr-16 my-auto">
                    </i-user>
                    {{ $t('pages.patients.impersonate') }}
                </div>
            </div>

            <el-form @submit="submit" class="col-12 col-lg-6">
                <p class="fw-b mb-16">{{  $t(`pages.psychologists.${update ? 'title_update' : 'title_new'}`) }}</p>

                <div class="row">
                    <div class="col-12">
                        <el-error class="mb-16" :error="server_error"></el-error>
                    </div>
                </div>

                <template slot="default">
                    <div class="row form-content">
                        <el-input class="col-12 col-md-6" v-model="data.first_name" :label="$t('form-elements.first_name')" name="first_name" :placeholder="$t('form-elements.first_name_placeholder')"></el-input>
                        <el-input class="col-12 col-md-6" v-model="data.last_name" :label="$t('form-elements.last_name')" name="last_name" :placeholder="$t('form-elements.last_name_placeholder')"></el-input>
                        <el-input class="col-12 col-md-6" v-model="data.email" :disabled="update" type="email" :label="$t('form-elements.email')" name="email" :placeholder="$t('form-elements.email_placeholder')"></el-input>
                        <el-select class="col-12 col-md-6" v-model="lang" @input="data.locale = lang.value" :options="languages" :label="$t('form-elements.language')" :placeholder="$t('form-elements.language_placeholder')"></el-select>
                        <el-select class="col-12 col-md-6" v-if="this.$route.params.id" v-model="status" @input="data.status = status.value" :options="statuses" :label="$t('form-elements.invite_status')" :placeholder="$t('form-elements.invite_status_placeholder')"></el-select>
                    </div>
                </template>

                <template slot="footer">
                    <div class="form-footer position-fixed px-lg-60">
                        <button type="submit" class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex" v-bind:class="{ disabled : loading }">
                            {{  $t(`pages.psychologists.${update ? 'cta_update' : 'cta_new'}`) }}
                            <template v-if="loading">
                                <i-loader class="ml-2 i-20 my-auto"></i-loader>
                            </template>
                            <template v-if="success">
                                <i-check class="ml-2 i-20 my-auto"></i-check>
                            </template>
                        </button>
                    </div>
                </template>
            </el-form>

            <div v-if="update" class="col-12 col-lg-6">

                <template v-if="users">
                    <el-table class="mb-32" :rows="users" :structure="usersStructure" :editable="false" detail="admin-show-patient">
                        <template #header>
                            <div class="col-12" style="margin-bottom: -32px">
                                <p class="fw-b mb-16">{{  $t('pages.psychologists.active_users') }}</p>
                                <div class="rounded bg-white-hover p-8 w-100 d-flex flex-row">
                                    {{  $t('pages.psychologists.active_users_amount') }}
                                    <span class="ml-auto my-atuo">{{ users.length }}</span>
                                </div>
                            </div>
                        </template>
                    </el-table>
                </template>

                <template v-if="codes">
                    <el-table class="mb-32" :rows="codes" :structure="codesStructure" :editable="false" detail="admin-codes-show">
                        <template #header>
                            <div class="col-12" style="margin-bottom: -32px">
                                <p class="fw-b mb-16">{{  $t('pages.psychologists.active_codes') }}</p>
                                <div class="rounded bg-white-hover p-8 w-100 d-flex flex-row">
                                    {{  $t('pages.psychologists.active_codes_amount') }}
                                    <span class="ml-auto my-atuo">{{ codes.length }}</span>
                                </div>
                            </div>
                        </template>
                    </el-table>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
import { ElTable } from '@/components/tables'
import { ElForm, ElInput, ElSelect, ElError } from '@/components/forms'

// Extends
import hasForm from '@/components/forms/has-form';
import hasLanguages from '@/components/forms/has-languages';

export default {
    name: 'page-psychologists-create-or-update',

    mixins: [hasForm, hasLanguages],

    components: { ElTable, ElForm, ElInput, ElSelect, ElError },

    data() {
        return {
            update: false,

            codes: [],
            users: [],

            status: '',
            statuses: [
                { label: this.$t('invite_status.pending'), value: 'pending' },
                { label: this.$t('invite_status.approved'), value: 'approved' },
                { label: this.$t('invite_status.disapproved'), value: 'denied' }
            ],
            data: {
                first_name: '',
                last_name: '',
                email: '',
                locale: 'nl-BE'
            },

            codesStructure: [
                { visible: true, label: this.$t('table.codes.code'), type: 'text', key: 'code', sortable: true, size: 'small' },
                { visible: true, label: this.$t('table.codes.users_available'), type: 'text', key: 'available', sortable: true },
                { visible: true, label: this.$t('table.codes.valid_to'), type: 'date', key: 'end_date', sortable: true },
            ],

            usersStructure: [
                { visible: true, label: this.$t('table.psychologists.name'), type: 'user', sortable: true, key: 'name' },
                { visible: true, label: this.$t('table.psychologists.email'), type: 'text', key: 'email', sortable: true },
                { visible: true, label: this.$t('table.psychologists.registered'), type: 'date', key: 'created_at', sortable: true },
                { visible: true, label: this.$t('table.psychologists.started_at'), type: 'date', key: 'started_at', sortable: true }
            ]

        }
    },

    mounted() {
        this.setLanguage('nl-BE')
        if (this.$route.params.id) {
            this.$store.dispatch('psychologists/read', this.$route.params.id).then((psychologist) => {
                this.update = true
                this.data = psychologist
                this.setLanguage(psychologist.locale)
                this.status = this.statuses.find((status) => status.value === psychologist.status)
            })
            this.$store.dispatch('psychologists/codes', this.$route.params.id).then((codes) => {
                this.codes = codes
            })
            this.$store.dispatch('psychologists/users', this.$route.params.id).then((users) => {
                this.users = users
            })
        }
    },

    methods: {
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    this.loading = true
                    this.$store.dispatch(`psychologists/${!this.update ? 'invite' : 'update'}`, this.data).then(
                        () => this.handleSuccess(!this.update ? 'create_psychologist' : 'update_psychologist'),
                        (e) => this.handleError(e)
                    )
                }
            })
        },
        impersonate() {
            this.$store.dispatch('user/impersonate', this.data.account_id).then(
                () => {
                    window.location.href = '/'
                }
            )
        }
    },

    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        }
    }
}
</script>

